module.exports = __webpack_public_path__ + "static/media/why-choose-elite-nannies.1fcfd791.jpg";